import React, { useState, useEffect } from 'react';

import { Modal } from 'react-bootstrap';

import AccordionDwelling from '../../modules/dwelling/components/AccordionDwelling';

type ModalDwellingInfoProps = {
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  dwellingInfo: any
};

const ModalDwellingInfo: React.FC<ModalDwellingInfoProps> = ({ show, setShow, dwellingInfo }) => {
  return (
    <Modal show={show} onHide={() => setShow(false)} className='modal-dwelling-info'>
      <AccordionDwelling info={dwellingInfo} dwellingAddress={dwellingInfo?.address
        && `${dwellingInfo.address.address.address.toLowerCase()},
         ${dwellingInfo.address.address.zip.toLowerCase()}
        ${dwellingInfo.address.address.city.toLowerCase()}`
      }
      />
    </Modal >
  );
};

export default ModalDwellingInfo;
